export default "__VITE_ASSET__ebrYo2nh__"